<div class="recent-searches-container">
  <div class="page-header">
    <h1 class="page-title">Recent Searches</h1>
    <p class="page-description">View and re-run your recent patient searches</p>
  </div>

  <div class="content-card">
    <div class="card-header" *ngIf="recentSearches.length > 0">
      <span class="result-count">{{ recentSearches.length }} recent search{{ recentSearches.length !== 1 ? 'es' : '' }}</span>
      <button mat-button color="warn" class="clear-all-btn" (click)="onClearAll()">
        <mat-icon>delete_sweep</mat-icon>
        Clear All
      </button>
    </div>

    <div class="searches-list" *ngIf="recentSearches.length > 0">
      <div
        class="search-item"
        *ngFor="let search of recentSearches"
        (click)="onSearchClick(search)">
        <div class="search-icon">
          <mat-icon>{{ getSearchIcon(search.type) }}</mat-icon>
        </div>
        <div class="search-details">
          <div class="search-query">{{ formatSearchDisplay(search) }}</div>
          <div class="search-meta">
            <span class="search-type">{{ getSearchTypeLabel(search.type) }}</span>
            <span class="separator">|</span>
            <span class="search-time">{{ formatTimestamp(search.timestamp) }}</span>
            <span class="separator" *ngIf="search.resultCount !== undefined">|</span>
            <span class="result-count-badge" *ngIf="search.resultCount !== undefined">
              {{ search.resultCount }} result{{ search.resultCount !== 1 ? 's' : '' }}
            </span>
          </div>
        </div>
        <button
          mat-icon-button
          class="remove-btn"
          (click)="onRemoveSearch($event, search)"
          matTooltip="Remove from history">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="empty-state" *ngIf="recentSearches.length === 0">
      <mat-icon class="empty-icon">history</mat-icon>
      <h3>No Recent Searches</h3>
      <p>Your recent patient searches will appear here</p>
      <button mat-raised-button color="primary" routerLink="/search">
        <mat-icon>search</mat-icon>
        Start Searching
      </button>
    </div>
  </div>
</div>
